<template>
    <Popover placement="bottom"
             :auto-adjust-overflow="false"
             :get-popup-container="getPopupContainer"
             @visibleChange="onVisit">
        <template #content>
            <div class="user-synopsis">
                <div class="synopsis-top">
                    <Link :href="route('user.show', {uid: user.uid})">
                        <span class="nickname">{{ user.nickname }}</span>
                    </Link>
                    <UserFocus :user="user">
                        <template #focused>
                            <div class="concern active">
                                <span>已关注</span>
                            </div>
                        </template>
                        <template #unFocused>
                            <div class="concern">
                                <span>+ 关注</span>
                            </div>
                        </template>
                    </UserFocus>
                </div>
                <Spin :spinning="loading">
                    <div class="synopsis-middle">
                        <template v-if="userRes?.recent_works">
                            <Link v-for="wo in userRes.recent_works"
                                  with-modal
                                  :href="route('work.show', {work: wo.id})"
                                  class="ml-2"
                            >
                                <div :style="{
                                        backgroundImage: 'url('+ wo.cover.url +')'
                                  }"
                                     class="middle-img"></div>
                            </Link>
                        </template>
                    </div>
                </Spin>
                <div class="synopsis-bottom">
                    <div class="bottom-span">人气
                        {{ user.view_count }}
                    </div>
                    <div class="bottom-span">作品
                        {{ user.apply_works_count }}
                    </div>
                    <div class="bottom-span">粉丝
                        {{ user.fans_users_count }}
                    </div>
                </div>
            </div>
        </template>
        <slot></slot>
    </Popover>
</template>

<script setup lang="ts">
import {Popover, Spin} from "ant-design-vue";
import Link from "@/Components/Link.vue";
import {getCurrentInstance, ref} from "vue";
import http from "@/utils/http";
import {route} from "@/utils/common";
import {User} from "../../../../env";
import UserFocus from "@/Components/UserFocus.vue";

const props = defineProps<{
    user: any
}>()

const loading = ref(true)
const userRes = ref<User & { recent_works: any[] }>()

const ins = getCurrentInstance()
const onVisit = async () => {
    if (userRes.value) {
        return
    }
    loading.value = true
    userRes.value = await http.get(route('api.user.find', {user: props.user.id}))
    loading.value = false
}

const getPopupContainer = (trigger: HTMLElement) => {
    return trigger.parentElement
}

</script>

<style scoped lang="less">
.user-synopsis {
    width: 280px;
    display: flex;
    flex-direction: column;
    padding: 0 5px;

    .synopsis-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 0 8px 0;

        .nickname {
            font-size: 16px;
            color: #2E2E2E;
            width: 200px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .concern {
            width: 50px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            font-size: 12px;
            border: 1px solid #EEEEEE;;
            color: #2E2E2E;
            transition: all .3s;

            &:hover {
                opacity: .6;
            }

            &.active {
                background: #EEEEEE;
            }
        }
    }

    .synopsis-middle {
        display: flex;
        justify-content: flex-start;
        height: 80px;

        .middle-img {
            width: 80px;
            height: 80px;
            background-size: cover;
        }
    }

    .synopsis-bottom {
        display: flex;
        align-items: center;
        margin: 10px 0 5px 0;

        .bottom-span {
            font-size: 12.6px;
            color: #2E2E2E;
            margin-right: 14px;
        }
    }
}
</style>
